import { render, staticRenderFns } from "./PayBoxStatement.vue?vue&type=template&id=76612cfa&scoped=true&"
import script from "./PayBoxStatement.vue?vue&type=script&lang=js&"
export * from "./PayBoxStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76612cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76612cfa')) {
      api.createRecord('76612cfa', component.options)
    } else {
      api.reload('76612cfa', component.options)
    }
    module.hot.accept("./PayBoxStatement.vue?vue&type=template&id=76612cfa&scoped=true&", function () {
      api.rerender('76612cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-statement/PayBoxStatement.vue"
export default component.exports